export default __webpack_public_path__ + "static/media/lexus.a2b89e13.svg";